module.exports = __webpack_public_path__ + "static/img/icon_benr.2c7eae43.svg";